module.exports = __webpack_public_path__ + "./img/download.4820407a0d06cd0b8bfb9506efde8a63.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/download.png
// module id = ./assets/images/download.png
// module chunks = 0